import { ProfileState } from '../../types';

const state: ProfileState = {
  requestError: {
    put: {
      message: '',
    },
  },
  user: {
    businessType: '',
    email: '',
    uuid: '',
    name: '',
    organization: '',
    phone: '',
  },
};

export default state;
